import { Component, EventListener, getComponentByDomNode, startComponents, stopComponents } from '@gondel/core';
import { GondelJqueryComponent } from '@gondel/plugin-jquery';
import { TooltipPopup } from '../elements/tooltip-popup/js/tooltip-popup';

export { TooltipPopup };

export interface ITooltipFetchService {
	uri: string;
	uriSuffix: string;
}

const enum Selectors {
	TooltipPopup = '.js-m-tooltip-popup',
}

@Component('Tooltip')
export class Tooltip extends GondelJqueryComponent {
	public static createInlineTooltip(
		$container: JQuery<HTMLElement>,
		inlineModifier: string,
		id: string,
		service: ITooltipFetchService
	): Promise<Tooltip> {
		return new Promise((resolve, reject) => {
			if ($container) {
				const $tooltip = $(`
					<span data-g-name="Tooltip" class="m-tooltip ${inlineModifier}">
						<span class="m-tooltip__icon js-m-tooltip__icon">
							<svg class="a-svg a-svg--notification-info-20" role="presentation" focusable="false" aria-hidden="true">
								<use xlink:href="/etc.clientlibs/slevo/clientlibs/site/resources/sprites.svg#notification-info-20"></use>
							</svg>
						</span>
					</span>
				`);
				$tooltip.appendTo($container);
				startComponents($tooltip)
					.then((startedComponents) => {
						const tooltip: Tooltip = startedComponents[0] as Tooltip;
						tooltip.async = true;
						tooltip.tooltipId = id;
						tooltip.service = service;
						resolve(tooltip);
					})
					.catch((err) => {
						reject(err);
					});
			} else {
				reject('Invalid container');
			}
		});
	}

	private async: boolean = false;
	private tooltipId: string | undefined = undefined;
	private service: ITooltipFetchService | undefined = undefined;
	private popup: TooltipPopup | undefined = undefined;

	public start() {
		this.async = this.$ctx.data('tooltip-async');
		if (this.async) {
			this.tooltipId = this.$ctx.data('tooltip-id');
			this.service = {
				uri: this.$ctx.data('tooltip-uri'),
				uriSuffix: this.$ctx.data('tooltip-uri-suffix'),
			};
		}
	}

	public sync() {
		const $popup = this.$ctx.find(Selectors.TooltipPopup);
		if ($popup && $popup.get(0)) {
			const tooltipPopup: TooltipPopup = getComponentByDomNode($popup.get(0)) as TooltipPopup;
			this.bindTooltipPopup(tooltipPopup);
		}
	}

	@EventListener('click')
	public _onHandleClick(ev: MouseEvent) {
		ev.preventDefault();
		ev.stopPropagation();
		if (this.popup && !this.popup.isVisible) {
			this.popup.toogleVisible(true);
		}
	}

	public get fetchContent(): boolean {
		return this.async;
	}

	public set fetchContent(resolved: boolean) {
		if (this.async) {
			this.async = resolved;
		}
	}

	public get id(): string | undefined {
		return this.tooltipId;
	}

	public get fetchService(): ITooltipFetchService | undefined {
		return this.service;
	}

	public bindTooltipPopup(tooltipPopup: TooltipPopup) {
		if (!this.popup && tooltipPopup) {
			this.popup = tooltipPopup.bindTooltip(this);
		}
	}
}
